module.exports = __webpack_public_path__ + "static/media/ahora50mg.59811a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/ahora50mg.png
// module id = 195
// module chunks = 0